import Dialog from 'core/modules/components/dialogs/components/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import './ChatD3Modal.scss';

function ChatD3Modal({ isOpen, onClose, title, url }) {
  return (
    <Dialog open={isOpen} onClose={onClose} title={title} size="full-screen" className="chat-d3-modal" showHeader={true} separator={true}>
      <div className="chat-d3-modal__content">
        <iframe src={url} width="100%" height="600" frameBorder="0" title={title} className="chat-d3-modal__iframe" allowFullScreen />
      </div>
    </Dialog>
  );
}

ChatD3Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ChatD3Modal;
